import { globalSpinnerController } from '@/components/Spinner';
import { PAGE_PATHS } from '@/constants/url';

const moveToAndroidLoginSuccessPage = ({
  customToken,
  providerType,
}: {
  customToken: string;
  providerType: string;
}) => {
  let androidLoginSuccessUrl = new URL(
    PAGE_PATHS.ANDROID_LOGIN_SUCCESS,
    window.location.href,
  );

  androidLoginSuccessUrl.searchParams.set('customToken', customToken);
  androidLoginSuccessUrl.searchParams.set('providerType', providerType);

  globalSpinnerController.hideSpinner();

  location.href = androidLoginSuccessUrl.href;
};

export { moveToAndroidLoginSuccessPage };
